import _ from "lodash"
import { create, StoreApi, UseBoundStore } from "zustand"

// TODO add random key to each route to be able to avoid circular routes setting wrong focus from previous route
interface FocusState {
  bannerIndex: Record<string, number>
  setBannerIndex: (route: string, bannerIndex: number) => void
  getBannerIndex: (route: string) => number
  tabBarSlug?: string
  setTabBarSlug: (tabBarSlug: string) => void

  focusStack: Record<string, { key: string; meta?: unknown }>
  addFocus: ({
    route,
    key,
    meta,
  }: {
    route: string
    key: string
    meta?: unknown
  }) => void
  findFocus: ({ route }: { route: string }) => string | undefined
  findMeta: ({ route }: { route: string }) => unknown
  clearMeta: ({ route }: { route: string }) => unknown
  clearFocus: () => void

  tabFocusGuard: boolean
}

const unlockFocus = _.debounce((set: (arg: Partial<FocusState>) => void) => {
  set({ tabFocusGuard: false })
}, 400)

export const focusStore: UseBoundStore<StoreApi<FocusState>> =
  create<FocusState>((set, getState) => ({
    bannerIndex: {},
    setBannerIndex: (route, bannerIndex) =>
      set({ bannerIndex: { ...getState().bannerIndex, [route]: bannerIndex } }),
    getBannerIndex: (route: string) => getState().bannerIndex[route] ?? 0,
    tabBarSlug: undefined,
    setTabBarSlug: (tabBarSlug: string) => {
      if (getState().tabBarSlug !== tabBarSlug) {
        set({ tabFocusGuard: true })
        unlockFocus(set)
      }
      set({ tabBarSlug })
    },

    focusStack: {},
    addFocus: ({ route, key, meta }) =>
      set({ focusStack: { ...getState().focusStack, [route]: { key, meta } } }),
    findFocus: ({ route }) => {
      return getState().focusStack?.[route]?.key
    },
    findMeta: ({ route }) => {
      return getState().focusStack?.[route]?.meta
    },
    clearMeta: ({ route }) => {
      const { key } = getState().focusStack?.[route]
      set({ focusStack: { ...getState().focusStack, [route]: { key } } })
    },
    clearFocus: () => set({ focusStack: {} }),

    tabFocusGuard: false,
  }))
